import React, { useState } from 'react';
import { PaperAirplaneIcon } from '@heroicons/react/24/outline';

interface CustomQuestionProps {
  onSubmit: (question: string) => void;
  isGenerating: boolean;
}

const CustomQuestion: React.FC<CustomQuestionProps> = ({ onSubmit, isGenerating }) => {
  const [question, setQuestion] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (question.trim() && !isGenerating) {
      onSubmit(question.trim());
      setQuestion('');
    }
  };

  return (
    <div className="space-y-4">
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <textarea
            value={question}
            onChange={(e) => setQuestion(e.target.value)}
            placeholder="Type your interview question here... (e.g., 'How would you handle a difficult team member?')"
            className="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-800 dark:text-white dark:placeholder-gray-400 resize-none"
            rows={3}
            disabled={isGenerating}
            required
          />
        </div>

        <button
          type="submit"
          disabled={!question.trim() || isGenerating}
          className="w-full sm:w-auto bg-gradient-to-r from-blue-500 to-indigo-600 text-white px-6 py-3 rounded-lg hover:from-blue-600 hover:to-indigo-700 disabled:from-gray-400 disabled:to-gray-500 transition-all duration-200 font-medium shadow-sm text-sm sm:text-base flex items-center justify-center"
        >
          {isGenerating ? (
            <>
              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
              Generating Answer...
            </>
          ) : (
            <>
              <PaperAirplaneIcon className="w-4 h-4 mr-2" />
              Ask Question
            </>
          )}
        </button>
      </form>
    </div>
  );
};

export default CustomQuestion;